"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _contexts = require("../../../contexts");
var _Input = _interopRequireDefault(require("../../fields/Input"));
var _nativePaymentPropsGenerator = require("../../../utils/native-payment/nativePaymentPropsGenerator");
var _iconUtils = require("../../icons/iconUtils");
var _nativePaymentUtils = require("../../../utils/native-payment/nativePaymentUtils");
var _fields = require("../../fields");
var _config = require("../../../i18n/config");
var _address = require("../../../core/services/address");
var _commonUtils = require("../../../utils/commonUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var NativeWidget = function NativeWidget(props) {
  var _props$block = props.block,
    inputCustomData = _props$block.inputCustomData,
    paymentInfo = _props$block.paymentInfo,
    setPaymentInfo = _props$block.setPaymentInfo;
  var _inputCustomData$cart = inputCustomData.cart.languageCode,
    languageCode = _inputCustomData$cart === void 0 ? _config.FALLBACK_LOCALE : _inputCustomData$cart,
    userDetails = inputCustomData.userDetails;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var _useContext = (0, _react.useContext)(_contexts.NativeContext),
    nativeDispatch = _useContext.dispatch,
    _useContext$state = _useContext.state,
    paymentMethodDetails = _useContext$state.paymentMethodDetails,
    statesResponse = _useContext$state.statesResponse;
  var CardTypes = paymentMethodDetails.cardTypes.map(function (cardType) {
    return (0, _iconUtils.getCardNumberIcon)(cardType);
  });
  var countryCodes = paymentMethodDetails.billingCountyCodes,
    enableStoreCardInfo = paymentMethodDetails.enableStoreCardInfo,
    widgetNameOrder = paymentMethodDetails.widgetNameOrder;
  var country = paymentInfo.country;
  (0, _react.useEffect)(function () {
    if (!(0, _commonUtils.isEmptyString)(country.value)) {
      (0, _address.getStatesForCountry)(country.value, nativeDispatch);
    }
  }, [country]);
  var handleChange = function handleChange(updatedPaymentInfo) {
    var _getCountryProps = (0, _nativePaymentPropsGenerator.getCountryProps)(formatMessage),
      countryKey = _getCountryProps.name;
    // If there is a change in country field, refresh the state field
    if (Object.prototype.hasOwnProperty.call(updatedPaymentInfo, countryKey)) {
      var _getStateProps = (0, _nativePaymentPropsGenerator.getStateProps)(formatMessage),
        stateKey = _getStateProps.name;
      var InitialState = (0, _nativePaymentUtils.getInitialState)();
      setPaymentInfo(_objectSpread(_objectSpread(_objectSpread({}, paymentInfo), updatedPaymentInfo), {}, _defineProperty({}, stateKey, InitialState[stateKey])));
    } else {
      setPaymentInfo(_objectSpread(_objectSpread({}, paymentInfo), updatedPaymentInfo));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, CardTypes), /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.cardNumber, (0, _nativePaymentPropsGenerator.getCardNumberProps)(formatMessage), {
    icon: (0, _iconUtils.getCardNumberIcon)((0, _nativePaymentUtils.getCardType)(paymentInfo.cardNumber.value)),
    customProps: {
      cardTypes: paymentMethodDetails.cardTypes
    },
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__card-details__container"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.cardExpiry, (0, _nativePaymentPropsGenerator.getCardExpiryProps)(formatMessage), {
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.cardCVV, (0, _nativePaymentPropsGenerator.getCardCVVProps)(formatMessage), {
    onChange: handleChange
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__card-holder-name__container"
  }, /*#__PURE__*/_react.default.createElement(_fields.NameOnCard, {
    nameOrder: widgetNameOrder,
    customProps: {
      firstName: paymentInfo.firstName.value,
      lastName: paymentInfo.lastName.value,
      fullName: paymentInfo.fullName.value
    },
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__card-details__container"
  }, /*#__PURE__*/_react.default.createElement(_fields.Country, _extends({}, paymentInfo.country, (0, _nativePaymentPropsGenerator.getCountryProps)(formatMessage), {
    locale: languageCode,
    countryCodes: countryCodes,
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.zipCode, (0, _nativePaymentPropsGenerator.getZipCodeProps)(formatMessage), {
    customProps: {
      country: paymentInfo.country.value
    },
    onChange: handleChange
  }))), /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.addressLine, (0, _nativePaymentPropsGenerator.getAddressLineProps)(formatMessage), {
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.addressLineTwo, (0, _nativePaymentPropsGenerator.getAddressLineTwoProps)(formatMessage), {
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__card-details__container"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.city, (0, _nativePaymentPropsGenerator.getCityProps)(formatMessage), {
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_fields.State, _extends({}, paymentInfo.state, (0, _nativePaymentPropsGenerator.getStateProps)(formatMessage), {
    onChange: handleChange,
    options: statesResponse
  }))), enableStoreCardInfo && !!(userDetails && userDetails.isLoggedIn) && /*#__PURE__*/_react.default.createElement(_fields.SaveCardCheckbox, {
    paymentInfo: paymentInfo,
    setPaymentInfo: setPaymentInfo
  }));
};
NativeWidget.propTypes = {
  block: _propTypes.default.object,
  customAuthCallBack: _propTypes.default.func,
  inputCustomData: _propTypes.default.object,
  payment: _propTypes.default.object,
  paymentInfo: _propTypes.default.object,
  setPaymentInfo: _propTypes.default.func,
  setProcessing: _propTypes.default.func
};
var _default = NativeWidget;
exports.default = _default;